<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="height" viewBox="0 0 20 20">
		<defs>
			<clipPath id="clip-path-41414">
				<rect
					id="Rectangle_14863"
					data-name="Rectangle 14863"
					width="20"
					height="20"
					transform="translate(60 719)"
					fill="#fff"
					stroke="#707070"
					stroke-width="1"
				/>
			</clipPath>
		</defs>
		<g id="Mask_Group_22274" data-name="Mask Group 22274" transform="translate(-60 -719)" clip-path="url(#clip-path-41414)">
			<g id="Group_44534" data-name="Group 44534" transform="translate(3.811 34.015)">
				<path
					id="Path_30445"
					data-name="Path 30445"
					d="M4.679,2.531a47.063,47.063,0,0,1,12.07,0,3.769,3.769,0,0,1,3.243,3.549,4.19,4.19,0,0,0-.983-.2,48.466,48.466,0,0,0-8.019,0A4.216,4.216,0,0,0,7.143,10.1v4.082A4.257,4.257,0,0,0,9.46,17.979L6.933,20.5A.714.714,0,0,1,5.714,20V16.162q-.518-.055-1.035-.122a3.78,3.78,0,0,1-3.25-3.79V6.322a3.779,3.779,0,0,1,3.25-3.789Z"
					transform="translate(54.761 683.558)"
					:fill="color"
				/>
				<path
					id="Path_30446"
					data-name="Path 30446"
					d="M15,7.143q-1.966,0-3.891.161a2.787,2.787,0,0,0-2.537,2.8v4.081a2.789,2.789,0,0,0,2.543,2.8q1.776.146,3.588.157l2.649,2.649a.714.714,0,0,0,1.219-.5V17.009l.314-.025a2.788,2.788,0,0,0,2.543-2.8V10.1a2.789,2.789,0,0,0-2.537-2.8Q16.952,7.143,15,7.143Z"
					transform="translate(54.761 683.558)"
					:fill="color"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ChatSvg',
	props: {
		height: { type: Number, default: 20 },
		width: { type: Number, default: 20 },
		color: { type: String, default: '#5d5ee1' },
	},
};
</script>

<style scoped lang="scss"></style>
